type Props = {
    count: number
    // How many of `count` are not filtered out so much as not yet moderated: stored,
    // usually by a refresh moments ago, and still being classified. The feed's
    // default moderation filter hides those, so without this the marker would
    // blame filters the moderator never set.
    awaiting?: number
    // Top-level comments the filters skipped between threads, or replies skipped
    // inside one thread.
    noun: 'comment' | 'reply'
}

const PLURAL = { comment: 'comments', reply: 'replies' }

export function gapLabel(count: number, noun: Props['noun'], awaiting = 0) {
    const some = (n: number) => `${n} ${n === 1 ? noun : PLURAL[noun]}`
    if (awaiting <= 0) return `${some(count)} filtered`
    if (awaiting >= count) return `${some(count)} awaiting moderation`
    return `${some(count - awaiting)} filtered, ${awaiting} awaiting moderation`
}

/**
 * Stands in for comments the filters exclude, where they fell, so the moderator
 * sees that something was skipped without losing the thread structure.
 * Neutral ink, never red: a skipped comment is not an alert.
 */
export default function GapMarker({ count, awaiting = 0, noun }: Props) {
    return (
        <div className="my-1 flex items-center gap-3 text-[13px] text-ink-500">
            <span className="h-px flex-1 bg-ink-200" />
            {gapLabel(count, noun, awaiting)}
            <span className="h-px flex-1 bg-ink-200" />
        </div>
    )
}
